<script>
    import { mapState } from "vuex";
    import { throttle } from "@/utils";
    import { metaInfo } from "@/core/MetaInfo";
    import TypographyWrapper from "@/components/TypographyWrapper";
    import { storyText } from "@bivan/storyText";

    export default {
        name: "Story",
        components: { TypographyWrapper },
        data() {
            return {
                scrollHandlerWithThrottle: throttle(this.scrollHandler, 25),
            };
        },
        computed: {
            ...mapState("Root", {
                staticText: (state) => state.site.staticTextContent,
            }),
            staticTextStory() {
                return this.staticText?.find((t) => t.key === "story")?.value;
            },
            storyText() {
                return storyText;
            },
        },
        mounted() {
            window.addEventListener("scroll", this.scrollHandler);
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.scrollHandler);
        },
        methods: {
            scrollHandler() {
                const elPosition = this.$refs.boomstarter.getBoundingClientRect();
                if (elPosition.top + 100 < window.innerHeight) {
                    window.removeEventListener("scroll", this.scrollHandler);
                    this.numberIncreaseAnimation("numberCash1", 0, 6);
                    this.numberIncreaseAnimation("numberCash2", 0, 765);
                    this.numberIncreaseAnimation("numberCash3", 0, 761);
                    this.numberIncreaseAnimation("numberSponsors", 0, 1984);
                    this.numberIncreaseAnimation("numberPercent", 0, 677);
                    this.numberIncreaseAnimation("numberWorkers", 0, 128);
                }
            },
            numberIncreaseAnimation(ref, start, end, duration = 2500) {
                let current = start;
                const delay = 30;
                const divider = duration / delay;
                const step = end / divider;
                const timer = setInterval(() => {
                    current += step;
                    this.$refs[ref].textContent = current.toFixed();
                    if (current >= end) {
                        clearInterval(timer);
                        this.$refs[ref].textContent = end;
                    }
                }, delay);
            },
        },
        metaInfo() {
            return metaInfo.getMeta("story");
        },
    };
</script>

<template>
    <div class="story-page">
        <div class="l-container">
            <typography-wrapper>
                <div class="page-title">Откройте отдых заново</div>
                <div class="story-page__text" v-html="staticTextStory"></div>
                <div class="story-page__image">
                    <img src="/static/bivan/assets/story/nadutie.gif" alt="" />
                    <span>
                        Чтобы надуть Биван, нужно всего лишь зачерпнуть им&nbsp;воздух. Пара
                        взмахов и&nbsp;все готово! Даже насос не&nbsp;понадобится.
                    </span>
                </div>
            </typography-wrapper>
        </div>
        <div class="story-page-boomstarter" ref="boomstarter">
            <div class="l-container">
                <div class="page-title">Биван&nbsp;&mdash; рекордсмен бумстартера</div>
                <div class="story-page-boomstarter__cash-wrap">
                    <div class="story-page-boomstarter__cash">
                        <span ref="numberCash1">6</span>&nbsp;<span ref="numberCash2">765</span
                        >&nbsp;<span ref="numberCash3">761</span>
                    </div>
                    <div class="story-page-boomstarter__currency">Р.</div>
                </div>
                <div class="story-page-boomstarter__description">
                    Собрано по&nbsp;итогам двух успешных кампаний на Бумстартере
                </div>
                <div class="story-page-boomstarter__info-list">
                    <div class="story-page-boomstarter__item">
                        <div class="story-page-boomstarter__image">
                            <img src="/static/bivan/assets/story/icon-1.svg" alt="" />
                        </div>
                        <h4 class="story-page-boomstarter__item-title" ref="numberSponsors">
                            1984
                        </h4>
                        <p class="story-page-boomstarter__item-description">
                            Общее количество спонсоров,<br />
                            поддерживающих проект
                        </p>
                    </div>
                    <div class="story-page-boomstarter__item">
                        <div class="story-page-boomstarter__image">
                            <div class="story-page-boomstarter__image">
                                <img src="/static/bivan/assets/story/icon-2.svg" alt="" />
                            </div>
                        </div>
                        <h4 class="story-page-boomstarter__item-title">
                            <span ref="numberPercent"></span> %
                        </h4>
                        <p class="story-page-boomstarter__item-description">
                            На столько были превышены<br />
                            первоначальные ожидания от сборов
                        </p>
                    </div>
                    <div class="story-page-boomstarter__item">
                        <div class="story-page-boomstarter__image">
                            <div class="story-page-boomstarter__image">
                                <img src="/static/bivan/assets/story/icon-3.svg" alt="" />
                            </div>
                        </div>
                        <h4 class="story-page-boomstarter__item-title" ref="numberWorkers">
                            128
                        </h4>
                        <p class="story-page-boomstarter__item-description">
                            Рабочих мест было создано<br />
                            для старта производства Биванов в Омске
                        </p>
                    </div>
                </div>
                <h3 class="page-title">О Биване написали и показали</h3>
                <div class="story-page-boomstarter__media-list">
                    <a
                        v-for="{ href, image } in storyText.links"
                        class="story-page-boomstarter__media-wrap"
                        target="_blank"
                        :href="href"
                    >
                        <img
                            class="story-page-boomstarter__media-img"
                            :src="`/static/bivan/assets/story/${image}`"
                            alt=""
                        />
                    </a>
                </div>
            </div>
        </div>
        <div class="story-page-features">
            <div class="l-container">
                <div class="page-title">Лежите где угодно!</div>
                <div class="story-page-features__list">
                    <div
                        v-for="{ title, text, image } in storyText.features"
                        class="story-page-features__item"
                    >
                        <div class="story-page-features__image">
                            <img :src="`/static/bivan/assets/story/${image}`" alt="" />
                        </div>
                        <span>{{ title }}</span>
                        <p v-html="text"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="story-page-team">
            <div class="l-container">
                <div class="page-title">Команда</div>
                <div class="story-page-team__list">
                    <div
                        v-for="{ name, text, image } in storyText.team"
                        class="story-page-team__item"
                    >
                        <img :src="`/static/bivan/assets/story/${image}`" alt="" />
                        <span>{{ name }}</span>
                        <p v-html="text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .story-page {
        padding-bottom: 40px;
        @include bp($bp-desktop-sm) {
            padding-bottom: 56px;
        }
    }

    .story-page__text {
        position: relative;
        margin-bottom: 32px;
        padding-bottom: 24px;
        &::before {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 200px;
            height: 2px;
            background-color: #e0e0e0;
            transform: translateX(-50%);
        }
        @include bp($bp-desktop-sm) {
            display: flex;
            margin: 0 -40px 56px;
            padding-bottom: 56px;
            &::before {
                width: 755px;
            }
        }
    }

    .story-page__text-col {
        @include bp($bp-desktop-sm) {
            padding: 0 40px;
        }
    }

    .story-page__image {
        margin-bottom: 40px;
        text-align: center;
        img {
            margin: 0 auto 20px;
        }
        span {
            display: block;
            max-width: 480px;
            margin: 0 auto;
            font-size: 16px;
            line-height: 30px;
        }
    }

    .story-page-boomstarter {
        padding: 24px 10px;
        margin-bottom: 40px;
        text-align: center;
        background-color: #f7f7f7;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            padding: 60px 10px 45px;
            margin-bottom: 60px;
        }
    }

    .story-page-boomstarter__cash-wrap {
        display: flex;
        justify-content: center;
    }

    .story-page-boomstarter__cash {
        color: var(--primary);
        font-size: 55px;
        font-weight: 700;
        white-space: nowrap;
        @include bp($bp-desktop-sm) {
            font-size: 100px;
        }
    }

    .story-page-boomstarter__currency {
        padding-top: 5px;
        color: #bdbdbd;
        font-size: 26px;
        @include bp($bp-desktop-sm) {
            font-size: 48px;
        }
    }

    .story-page-boomstarter__description {
        color: var(--secondary-text);
        font-size: 16px;
        font-weight: 400;
        line-height: 29px;
        padding: 20px 0;
    }

    .story-page-boomstarter__info-list {
        margin-bottom: 30px;
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 50px;
        }
    }

    .story-page-boomstarter__item {
        position: relative;
        padding: 15px 50px;
        @include bp($bp-desktop-sm) {
            flex-basis: 33.3333%;
            max-width: 33.3333%;
        }
    }

    .story-page-boomstarter__image {
        margin: 0 auto;
        width: 120px;
        height: 120px;
    }

    .story-page-boomstarter__item-title {
        font-weight: bold;
        font-size: 36px;
        line-height: 80px;
    }

    .story-page-boomstarter__item-description {
        color: var(--secondary-text);
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
    }

    .story-page-boomstarter__media-list {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        @include bp($bp-desktop-sm) {
        }
    }

    .story-page-boomstarter__media-wrap {
        display: block;
        padding: 0 12px 12px;
        flex-basis: 33.3333%;
        max-width: 33.3333%;
        img {
            margin: 0 auto;
        }
        @include bp($bp-desktop-sm) {
            flex-basis: auto;
            max-width: 100%;
        }
    }

    .story-page-boomstarter__media-img {
        @include bp($bp-desktop-sm) {
            transition: transform 0.2s ease-in;
            &:hover {
                transform: scale(1.1);
            }
        }
    }

    .story-page-features__list {
        margin-bottom: 20px;
        @include bp($bp-desktop-sm) {
            display: flex;
            margin-bottom: 40px;
        }
    }

    .story-page-features__item {
        padding: 0 20px 36px;
        text-align: center;
        span {
            display: block;
            margin-bottom: 10px;
            font-size: 20px;
            font-weight: 500;
        }
        p {
            font-size: 14px;
            line-height: 28px;
        }
        @include bp($bp-desktop-sm) {
            flex-basis: 25%;
            max-width: 25%;
            padding: 0 40px 36px;
        }
    }

    .story-page-features__image {
        width: 140px;
        height: 140px;
        margin: 0 auto 25px;
        border-radius: 50%;
        background-color: #fff;
        overflow: hidden;
        img {
            width: 100%;
            transform: translate(10px, 10px);
        }
    }

    .story-page-team__list {
        @include bp($bp-desktop-sm) {
            display: flex;
        }
    }

    .story-page-team__item {
        padding: 0 20px 36px;
        text-align: center;
        img {
            width: 180px;
            height: 180px;
            margin: 0 auto 25px;
        }
        span {
            display: block;
            margin-bottom: 10px;
            font-size: 20px;
            font-weight: 500;
        }
        p {
            font-size: 14px;
            line-height: 28px;
        }
        @include bp($bp-desktop-sm) {
            flex-basis: 33.3333%;
            max-width: 33.3333%;
        }
    }
</style>
